module.exports = __webpack_public_path__ + "media/icons/arrow-left-square@2x-a55ca25f.png";